import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import IconMenu from 'app/common/IconMenu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';

import i18n from 'app/common/i18n';

import { styled } from '@mui/material/styles';

import styles from './nav-styles';

const Root = styled('div')(({ theme }) => {
  const classes = styles(theme);

  return classes.root;
});

const StyledAppBar = styled(AppBar)(({ theme }) => {
  const classes = styles(theme);

  return classes.appBar;
});

const FlexTitle = styled(Typography)(({ theme }) => {
  const classes = styles(theme);

  return classes.flex;
});

@connect(({ app }) => ({ app }))
@i18n
class NavBar extends Component {
  static propTypes = {
    desktop: PropTypes.bool.isRequired,
    drawer: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
    user: PropTypes.object
  };

  toggleDrawer = () => {
    return this.props.toggleDrawer(!this.props.drawer);
  };

  render() {
    const { app, drawer, desktop, user, logout } = this.props;

    return (
      <Root>
        <StyledAppBar
          position="fixed"
          style={{ paddingLeft: desktop ? 250 : 0 }}
        >
          <Toolbar>
            {!desktop && !drawer ? (
              <IconButton
                color="inherit"
                aria-label="Menu"
                onClick={this.toggleDrawer}
              >
                <Icon color="inherit">menu</Icon>
              </IconButton>
            ) : null}

            <FlexTitle variant="h6" color="inherit">
              {app.get('title')}
            </FlexTitle>

            <IconMenu
              color="inherit"
              icon={<Icon color="inherit">account_circle</Icon>}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              options={
                user
                  ? [
                      user.get('role') !== 'admin' ? (
                        <MenuItem
                          key="profile"
                          component={Link}
                          className="profile-link"
                          to="/profile"
                        >
                          <ListItemIcon>
                            <Icon>settings</Icon>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.props.i18n('My Account')}
                          />
                        </MenuItem>
                      ) : null,
                      <MenuItem
                        key="logout"
                        onClick={logout}
                        className="logout"
                      >
                        <ListItemIcon>
                          <Icon>lock</Icon>
                        </ListItemIcon>
                        <ListItemText primary={this.props.i18n('Sign Out')} />
                      </MenuItem>
                    ].filter(Boolean)
                  : [
                      <MenuItem key="signup" component={Link} to="/signup">
                        <ListItemIcon>
                          <Icon>person_add</Icon>
                        </ListItemIcon>
                        <ListItemText
                          primary={this.props.i18n('New landlord')}
                        />
                      </MenuItem>,
                      <MenuItem key="signin" component={Link} to="/">
                        <ListItemIcon>
                          <Icon>lock_open</Icon>
                        </ListItemIcon>
                        <ListItemText primary={this.props.i18n('Sign In')} />
                      </MenuItem>
                    ]
              }
            />
          </Toolbar>
        </StyledAppBar>
      </Root>
    );
  }
}

export default NavBar;
